// extracted by mini-css-extract-plugin
export default {"registr":"PurchasesRegistr_registr__3RsgW","search":"PurchasesRegistr_search__oQGTH","registryFilterWrap":"PurchasesRegistr_registryFilterWrap__ger7J"};